// Device-based browsing history (works for guests and logged-in shoppers).
// Stores a compact record of viewed products to power the "Selected for you" section.
const KEY = "hg_browsing_history";
const MAX = 24;

export const getHistory = () => {
  try {
    const parsed = JSON.parse(localStorage.getItem(KEY) || "[]");
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

export const recordView = (product) => {
  if (!product || !product.id) return;
  try {
    const list = getHistory().filter((h) => h.id !== product.id);
    list.unshift({
      id: product.id,
      category: product.category || "",
      brand: product.brand || "",
      ts: Date.now(),
    });
    localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
  } catch {
    /* localStorage unavailable — ignore */
  }
};

// Rank a catalogue against browsing history: recently viewed first, then
// similar pieces (same brand/category), then a featured fallback.
export const buildRecommendations = (allProducts, limit = 8) => {
  const all = Array.isArray(allProducts) ? allProducts : [];
  const history = getHistory();
  const histIds = history.map((h) => h.id);
  const brands = new Set(history.map((h) => h.brand).filter(Boolean));
  const cats = new Set(history.map((h) => h.category).filter(Boolean));
  const byId = Object.fromEntries(all.map((p) => [p.id, p]));

  const recentlyViewed = histIds.map((id) => byId[id]).filter(Boolean);

  const similar = all
    .filter((p) => !histIds.includes(p.id))
    .map((p) => ({ p, score: (brands.has(p.brand) ? 2 : 0) + (cats.has(p.category) ? 1 : 0) }))
    .filter((x) => x.score > 0)
    .sort((a, b) => b.score - a.score || (b.p.featured ? 1 : 0) - (a.p.featured ? 1 : 0))
    .map((x) => x.p);

  const seen = new Set();
  let blended = [...recentlyViewed, ...similar].filter((p) => !seen.has(p.id) && seen.add(p.id));

  if (blended.length === 0) {
    blended = all.filter((p) => p.featured);
    if (blended.length === 0) blended = all;
  }
  return blended.slice(0, limit);
};
